import React from "react";
import { SearchProvider } from "./src/context/SearchContext";
import { CartProvider } from "./src/context/CartContext";

export const wrapRootElement = ({ element }) => (
    <SearchProvider indexUrl="/search/index.json">
        <CartProvider>{element}</CartProvider>
    </SearchProvider>
);
